import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { Box, Button, Typography, CircularProgress } from "@material-ui/core";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import EmailIcon from "@material-ui/icons/Email";

const backendUrl = () =>
  process.env.REACT_APP_BACKEND_URL || "https://api.floow.chat";

// Para onde a pessoa cai depois de pagar. Sem isto ela via so o aviso do
// checkout e ficava sem saber para onde ir.
const Obrigado = () => {
  const history = useHistory();
  const [segundos, setSegundos] = useState(15);
  const [logo, setLogo] = useState(null);
  const [nomeApp, setNomeApp] = useState("");

  // Mesma configuracao que o login usa: trocando a marca, esta pagina segue.
  useEffect(() => {
    const base = backendUrl();
    const pegar = key =>
      fetch(`${base}/public-settings/${key}?token=wtV`)
        .then(r => r.json())
        .catch(() => null);

    Promise.all([pegar("appLogoSite"), pegar("appName")]).then(
      ([arquivo, nome]) => {
        if (arquivo) setLogo(`${base}/public/${arquivo}`);
        if (nome) setNomeApp(String(nome));
      }
    );
  }, []);

  useEffect(() => {
    if (segundos <= 0) {
      history.push("/login");
      return;
    }
    const t = setTimeout(() => setSegundos(s => s - 1), 1000);
    return () => clearTimeout(t);
  }, [segundos, history]);

  return (
    <Box
      style={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: "linear-gradient(160deg,#eff6ff 0%,#f8fafc 60%)",
        padding: 20
      }}
    >
      <Box
        style={{
          maxWidth: 540,
          width: "100%",
          background: "#ffffff",
          borderRadius: 16,
          padding: "36px 32px 40px",
          textAlign: "center",
          boxShadow: "0 10px 40px rgba(15,23,42,0.10)"
        }}
      >
        {logo ? (
          <img
            src={logo}
            alt={nomeApp || "Logo"}
            style={{ maxWidth: 190, maxHeight: 64, marginBottom: 22 }}
          />
        ) : (
          nomeApp && (
            <Typography
              variant="h6"
              style={{ color: "#0f172a", fontWeight: 700, marginBottom: 22 }}
            >
              {nomeApp}
            </Typography>
          )
        )}

        <Box>
          <CheckCircleIcon style={{ fontSize: 60, color: "#22c55e" }} />
        </Box>

        <Typography
          variant="h5"
          style={{ color: "#0f172a", fontWeight: 700, marginTop: 10 }}
        >
          Pagamento confirmado!
        </Typography>

        <Typography
          variant="body1"
          style={{ color: "#475569", marginTop: 12, lineHeight: 1.6 }}
        >
          Obrigado pela confiança. A sua conta já está criada e liberada.
        </Typography>

        <Box
          style={{
            marginTop: 24,
            padding: 16,
            background: "#f0f9ff",
            border: "1px solid #3b82f6",
            borderRadius: 10,
            textAlign: "left"
          }}
        >
          <Typography
            variant="body2"
            style={{ color: "#1e40af", lineHeight: 1.6 }}
          >
            <EmailIcon
              style={{ fontSize: 18, marginRight: 6, verticalAlign: "middle" }}
            />
            <strong>Confira o seu e-mail.</strong> Enviamos os dados de acesso,
            com a sua senha. Se não encontrar, olhe na caixa de spam ou
            promoções.
          </Typography>
        </Box>

        <Button
          variant="contained"
          color="primary"
          fullWidth
          style={{ marginTop: 24, padding: "12px 0", fontWeight: 600 }}
          onClick={() => history.push("/login")}
        >
          Ir para o login
        </Button>

        <Box
          style={{
            marginTop: 16,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: 8
          }}
        >
          <CircularProgress size={14} />
          <Typography variant="caption" style={{ color: "#94a3b8" }}>
            Levando você para o login em {segundos}s
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default Obrigado;
